import React, { useContext, useEffect } from "react";
import Layout from "../shared/Layout/Layout";
import PageIntro from "../shared/PageIntro/PageIntro";
import { objectiveContext } from "../../context/Objective";
import ComingSoon from "../shared/ComingSoon/ComingSoon";

function OurVisions() {
  useEffect(() => {
    document.title = "Our Story - MetaWorldX";
  }, []);

  const { setSolutionActive, setCompanyActive } = useContext(objectiveContext);

  return (
    <Layout>
      <div
        onClick={() => {
          setSolutionActive(false);
          setCompanyActive(false);
        }}
        className="mt-[60px]"
      >
        <>
          <PageIntro headingOne={"Our Story"} headingTwo={"Home < Our Story"} />
        </>
        <div className="flex justify-center items-center flex-col pt-14 pb-6 max-[481px]:pt-6">
          <ComingSoon />
        </div>
        <>
          <div className="relative w-full h-[90vh] max-[1200px]:h-[90vh] flex items-center flex-col justify-center bg-[url(/public/assets/home_bg.svg)] bg-cover bg-no-repeat bg-center">
            <img src="/assets/home_img.svg" alt="" />
          </div>
        </>
        {/* <Row gutter={[0, 8]}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
            <div className="px-14 py-6  max-[481px]:px-2">
              <p className="text-[50px] text-[#ffffff] font-bold max-[481px]:text-[18px] text-center">
                Our Vision
              </p>
              <p className="text-[18px] text-[#ffffff] font-normal max-[481px]:text-[14px] text-justify">
                Millions of people around the world rely on being sold a vision
                before they invest or purchase a property Doctors require the
                latest technology to train on and plan for surgeries Engineers
                and data analysts use Live real time data to manage risks,
                movement of goods and people. Cities require the latest
                technology to conduct simulations in order to prepare for and
                avoid catastrophic and life threatening natural events MWX
                commitment to accurate and high-quality 3D visualization also
                applies to its exterior projects. As lifestyle becomes
                increasingly tied to real estate, more and more people want an
                efficient way to understand their neighborhood. 3D exterior
                exploration offers all that and more. From architectural
                highlights, landscaping, walking score, local points of
                interest, even what the area looks like during sunrise or
                sunset, everything you want to communicate about a project from
                development and sales perspective is neatly contained within an
                intuitive visual application. Whether it is presenting in front
                of city council, investors, or home buyers, MWX interactive
                visualization platform is a testament to your commitment to
                transparency, progress, and value to customers.
              </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
            <div className="py-14 max-[481px]:py-2">
              <Image src="/ourVision.svg" preview={false} alt="img" />
            </div>
          </Col>
        </Row> */}
        {/* <div className="flex justify-center items-center flex-col">
          <div className="text-[48px] font-bold text-[#ffffff] max-[481px]:text-[18px] mt-14">
            Our Story
          </div>
          <div className="text-[18px] font-normal text-[#ffffff] max-[481px]:text-[12px] text-center px-2">
            We should respond to climate change, support zero-carbon development
            and build more efficient and resilient cities by enhancing the
            benefits of digital twin technologies. MWX builds interactive
            digital twins and environments using the Unreal Engine. With
            cloud-streaming technology and high-fidelity visualization, our
            vision is to deliver immersive experiences on any device, anywhere,
            anytime.
          </div>
        </div>
        <br />
        <Row gutter={[0, 8]}>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
            <div className="px-14 max-[481px]:px-0 flex justify-center items-center">
              <Image src="/ourVisionStory.svg" preview={false} alt="img" />
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
            <div className="px-14 max-[481px]:px-0 flex justify-center items-center">
              <Image src="/ourVisionStory.svg" preview={false} alt="img" />
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
            <div className="px-14 max-[481px]:px-0 flex justify-center items-center">
              <Image src="/ourVisionStory.svg" preview={false} alt="img" />
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={6} xl={6} xxl={6}>
            <div className="px-14 max-[481px]:px-0 flex justify-center items-center">
              <Image src="/ourVisionStory.svg" preview={false} alt="img" />
            </div>
          </Col>
        </Row>
        <br />
        <br />
        <br /> */}
      </div>
    </Layout>
  );
}

export default OurVisions;
